import { getItemTypeLabel } from '../../../../../../constants/inventoryLabels'
import { DEFAULT_WAREHOUSE_CODE } from '../constants/inventoryWarehouse'

const UNIT_LABELS = {
  U: { singular: 'unidad', plural: 'unidades' },
  UN: { singular: 'unidad', plural: 'unidades' },
  UND: { singular: 'unidad', plural: 'unidades' },
  KG: { singular: 'kg', plural: 'kg' },
  G: { singular: 'gr', plural: 'gr' },
  GR: { singular: 'gr', plural: 'gr' },
  L: { singular: 'lt', plural: 'lt' },
  LT: { singular: 'lt', plural: 'lt' },
  ML: { singular: 'ml', plural: 'ml' },
  M: { singular: 'm', plural: 'm' },
  M2: { singular: 'm2', plural: 'm2' },
  M3: { singular: 'm3', plural: 'm3' },
  CAJA: { singular: 'caja', plural: 'cajas' },
  PACK: { singular: 'pack', plural: 'packs' },
  BOLSA: { singular: 'bolsa', plural: 'bolsas' },
  SACO: { singular: 'saco', plural: 'sacos' },
  OZ: { singular: 'oz', plural: 'oz' }
}

export const toBoolean = value => value === true || value === 1 || value === '1' || value === 'true'

export const resolveItemType = row => row?.item_type ?? row?.itemType ?? row?.tipo_item ?? ''

export const resolveItemUnit = (row, fallback = 'UN') => {
  const unit = String(row?.unit ?? row?.unidad ?? row?.uom ?? row?.measureUnit ?? '').trim().toUpperCase()
  return unit || fallback
}

export const getReadableUnitLabel = (unit, quantity = 2) => {
  const normalizedUnit = String(unit || '').trim().toUpperCase()
  if (!normalizedUnit) return ''

  const definition = UNIT_LABELS[normalizedUnit]
  if (!definition) return normalizedUnit.toLowerCase()

  return Number(quantity) === 1 ? definition.singular : definition.plural
}

export const resolveMovementType = row =>
  row?.movementType ?? row?.movement_type ?? row?.type ?? row?.tipo ?? ''

export const resolveWarehouseLabel = row =>
  row?.warehouseCode ??
  row?.warehouse_code ??
  row?.warehouseName ??
  row?.warehouse_name ??
  row?.bodega_codigo ??
  row?.bodega_nombre ??
  '-'

export const resolveStockQuantity = row =>
  row?.quantityOnHand ?? row?.quantity_on_hand ?? row?.quantity ?? row?.cantidad ?? row?.stock

export const resolveMovementQuantity = row =>
  row?.deltaQty ?? row?.delta_qty ?? row?.quantity ?? row?.cantidad

export const resolveMovementReference = row =>
  row?.referenceCode ?? row?.reference_code ?? row?.referenceType ?? row?.reference_type ?? '-'

export const resolveItemId = row => Number(row?.id ?? row?.item_id ?? row?.itemId ?? 0)

export const resolveWarehouseId = row => Number(row?.id ?? row?.warehouse_id ?? row?.warehouseId ?? 0)

export const resolveRecipeId = recipe => Number(recipe?.id ?? recipe?.recipe_id ?? recipe?.recipeId ?? 0)

export const isProtectedWarehouse = row => {
  const code = String(row?.code ?? row?.codigo ?? '').trim().toUpperCase()
  const isDefault = toBoolean(row?.is_default ?? row?.isDefault ?? row?.default)
  return code === DEFAULT_WAREHOUSE_CODE || isDefault
}

export const getItemOptionLabel = row => {
  const sku = row?.sku ? `${row.sku} · ` : ''
  const name = row?.name ?? row?.nombre ?? 'Sin nombre'
  return `${sku}${name} (${getItemTypeLabel(resolveItemType(row))})`
}

export const getErrorMessage = error => {
  const message = error?.response?.data?.message
  const correlationId = error?.response?.data?.correlationId
  const suffix = correlationId ? ` (cid: ${correlationId})` : ''

  if (Array.isArray(message)) return `${message.join(' · ')}${suffix}`
  if (typeof message === 'string') return `${message}${suffix}`

  return `${error?.message || 'No se pudo completar la operación.'}${suffix}`
}
